import {
  VALIDATE_ALLOWED_PASSWORD_CHARACTERS_REGEX,
  VALIDATE_LOWERCASE_REGEX,
  VALIDATE_SPECIAL_CHARACTERS_REGEX,
  VALIDATE_UPPERCASE_REGEX,
} from './regex.constants'

export const isValidPassword = (password: string): boolean =>
  password.length >= 8 &&
  password.length <= 32 &&
  VALIDATE_UPPERCASE_REGEX.test(password) &&
  VALIDATE_LOWERCASE_REGEX.test(password) &&
  VALIDATE_SPECIAL_CHARACTERS_REGEX.test(password) &&
  VALIDATE_ALLOWED_PASSWORD_CHARACTERS_REGEX.test(password)
